/*
  ATENAS STORE · Página de producto (variantes, galería, cantidad, barra fija)
  ---------------------------------------------------------------------------
  Lo usan las secciones kicks-main-product, heepzy-main-product y
  heepzy-featured-product. Todo se conecta con atributos data-*:

  [data-atn-product]           contenedor del producto
  [data-atn-variants]          <script type="application/json"> con las variantes
  [data-atn-option="0|1|2"]    inputs radio de cada opción (color, talla…)
  [data-atn-option-value="i"]  texto que muestra el valor elegido
  [data-atn-variant-input]     input oculto name="id"
  [data-atn-price] [data-atn-compare] [data-atn-save]  precios
  [data-atn-submit]            botón agregar al carrito
  [data-atn-gallery]           carril de imágenes (scroll-snap)
  [data-atn-media-id]          cada imagen del carril
  [data-atn-thumb]             miniaturas (data-media-id)
  [data-atn-prev] [data-atn-next] [data-atn-dot]
  [data-atn-qty-minus] [data-atn-qty-plus]
  [data-atn-sticky]            barra fija inferior (móvil)
  [data-atn-modal-open="id"]   abre un <dialog id="..."> (guía de tallas)
*/
(function () {
  function initProduct(root) {
    if (root.__atnReady) return;
    root.__atnReady = true;

    var dataEl = root.querySelector('[data-atn-variants]');
    var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
    var inputs = Array.prototype.slice.call(root.querySelectorAll('[data-atn-option]'));
    var idInput = root.querySelector('[data-atn-variant-input]');
    var submit = root.querySelector('[data-atn-submit]');
    var updateUrl = root.hasAttribute('data-update-url');

    function selected() {
      var opts = [];
      inputs.forEach(function (i) {
        if (i.checked || i.tagName === 'SELECT') opts[Number(i.dataset.atnOption)] = i.value;
      });
      return opts;
    }

    function findVariant(opts) {
      return variants.find(function (v) {
        return v.options.every(function (o, idx) { return opts[idx] === undefined || opts[idx] === o; });
      });
    }

    function markAvailability(opts) {
      inputs.forEach(function (input) {
        var idx = Number(input.dataset.atnOption);
        var test = opts.slice();
        test[idx] = input.value;
        var ok = variants.some(function (v) {
          return v.available && v.options.every(function (o, j) { return test[j] === undefined || test[j] === o; });
        });
        var label = input.closest('label') || root.querySelector('label[for="' + input.id + '"]');
        if (label) label.classList.toggle('is-unavailable', !ok);
      });
    }

    function setText(sel, txt) {
      root.querySelectorAll(sel).forEach(function (el) {
        el.innerHTML = txt || '';
        el.hidden = !txt;
      });
    }

    function update() {
      var opts = selected();
      opts.forEach(function (val, idx) {
        root.querySelectorAll('[data-atn-option-value="' + idx + '"]').forEach(function (el) { el.textContent = val; });
      });
      markAvailability(opts);
      inputs.forEach(function (i) { var l = i.closest('label'); if (l) l.classList.toggle('is-checked', i.checked); });
      var v = findVariant(opts);
      if (!v) {
        if (submit) { submit.disabled = true; setSubmitText(submit.dataset.textUnavailable); }
        return;
      }
      if (idInput) idInput.value = v.id;
      setText('[data-atn-price]', v.price);
      setText('[data-atn-compare]', v.compare);
      setText('[data-atn-save]', v.save);
      if (submit) {
        submit.disabled = !v.available;
        setSubmitText(v.available ? submit.dataset.textAdd : submit.dataset.textSoldout);
      }
      root.querySelectorAll('[data-atn-sticky-submit]').forEach(function (b) {
        b.disabled = !v.available;
        b.textContent = v.available ? submit.dataset.textAdd : submit.dataset.textSoldout;
      });
      if (v.media) goToMedia(v.media);
      if (updateUrl && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
      root.dispatchEvent(new CustomEvent('atenas:variant', { detail: v, bubbles: true }));
    }

    function setSubmitText(txt) {
      if (!submit) return;
      var t = submit.querySelector('[data-atn-submit-text]');
      (t || submit).textContent = txt;
    }

    // ---- Galería ----
    var gallery = root.querySelector('[data-atn-gallery]');
    var slides = gallery ? Array.prototype.slice.call(gallery.querySelectorAll('[data-atn-media-id]')) : [];
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-atn-thumb]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-atn-dot]'));
    var current = 0;

    function setActive(index) {
      current = index;
      thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === index); t.setAttribute('aria-current', i === index); });
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === index); });
    }

    function goTo(index, smooth) {
      if (!gallery || !slides[index]) return;
      gallery.scrollTo({ left: slides[index].offsetLeft - gallery.offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
      setActive(index);
    }

    function goToMedia(mediaId) {
      var idx = slides.findIndex(function (s) { return String(s.dataset.atnMediaId) === String(mediaId); });
      if (idx > -1) goTo(idx);
    }

    if (gallery) {
      var ticking = false;
      gallery.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          var w = gallery.clientWidth || 1;
          setActive(Math.round(gallery.scrollLeft / w));
          ticking = false;
        });
      }, { passive: true });
    }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { goTo(i); }); });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { goTo(i); }); });
    root.querySelectorAll('[data-atn-prev]').forEach(function (b) {
      b.addEventListener('click', function () { goTo(current > 0 ? current - 1 : slides.length - 1); });
    });
    root.querySelectorAll('[data-atn-next]').forEach(function (b) {
      b.addEventListener('click', function () { goTo(current < slides.length - 1 ? current + 1 : 0); });
    });

    // ---- Cantidad ----
    root.querySelectorAll('[data-atn-qty-minus],[data-atn-qty-plus]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = btn.parentElement.querySelector('input[name="quantity"]');
        if (!input) return;
        var n = Number(input.value || 1) + (btn.hasAttribute('data-atn-qty-plus') ? 1 : -1);
        input.value = Math.max(1, n);
      });
    });

    // ---- Barra fija (móvil) ----
    var sticky = root.querySelector('[data-atn-sticky]');
    if (sticky && submit && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        sticky.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
      }).observe(submit);
      sticky.querySelectorAll('[data-atn-sticky-submit]').forEach(function (b) {
        b.addEventListener('click', function () {
          var form = submit.closest('form');
          if (form && form.requestSubmit) form.requestSubmit(submit); else submit.click();
        });
      });
    }

    // ---- Modales (guía de tallas) ----
    root.querySelectorAll('[data-atn-modal-open]').forEach(function (b) {
      b.addEventListener('click', function () {
        var d = document.getElementById(b.dataset.atnModalOpen);
        if (d && d.showModal) d.showModal();
      });
    });
    root.querySelectorAll('dialog').forEach(function (d) {
      d.addEventListener('click', function (e) { if (e.target === d || e.target.closest('[data-atn-modal-close]')) d.close(); });
    });

    inputs.forEach(function (i) { i.addEventListener('change', update); });

    // Selección con un solo toque (iPhone a veces no pasa el toque del <label> al radio oculto)
    function pick(label) {
      var input = label && label.querySelector('[data-atn-option]');
      if (!input || input.checked) return;
      input.checked = true;
      update();
    }
    var down = null;
    root.addEventListener('pointerdown', function (e) {
      var l = e.target.closest('label');
      down = l && l.querySelector('[data-atn-option]') ? { l: l, x: e.clientX, y: e.clientY } : null;
    }, { passive: true });
    root.addEventListener('pointerup', function (e) {
      if (!down || e.pointerType === 'mouse') return;
      var l = e.target.closest('label');
      if (l === down.l && Math.abs(e.clientX - down.x) < 10 && Math.abs(e.clientY - down.y) < 10) pick(l);
      down = null;
    });
    root.addEventListener('click', function (e) {
      var l = e.target.closest('label');
      if (!l || !l.querySelector('[data-atn-option]')) return;
      e.preventDefault();
      pick(l);
    });
    if (inputs.length) markAvailability(selected());
    inputs.forEach(function (i) { var l = i.closest('label'); if (l) l.classList.toggle('is-checked', i.checked); });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-atn-product]').forEach(initProduct);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();

  // Vuelve a iniciar cuando se edita una sección en el editor de temas
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  window.AtenasProduct = { init: initAll };
})();
